import { displayAmount } from "../PayslipHelper";
import { _getObjectsSection } from "./body-sections/ObjectsSection";
import { _getContributions } from "./body-sections/ContributionsSection";
import { _getDeductions } from "./body-sections/DeductionsSection";
export default function BodyContent({
  styles,
  item,
  displayValues,
  computedValues,
  apRate,
  checkCase,
  accountsTitle,
}) {
  const params_1 = {
    item,
    checkCase,
    styles,
    displayValues,
  };
  const params_2 = {
    item,
    styles,
    accountsTitle,
  };
  
  return (
    <>
      {checkCase("isBasicGeneral") && (
        <div style={styles.salaryRowSection}>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>Basic Salary Rate</p>
            <p style={styles.amount}>
              {displayAmount(displayValues.basicRate)}
            </p>
          </div>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>PERA/ADA</p>
            <p style={styles.amount}>{displayAmount(displayValues.peraAda)}</p>
          </div>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>TOTAL EARNED</p>
            <div style={styles.amtBoundary}>
              <p style={{ ...styles.amount }}>
                <b>{displayAmount(computedValues.totalEarned)}</b>
              </p>
            </div>
          </div>
        </div>
      )}
      {(checkCase("isApGeneralNewly") || checkCase("isApBackPay")) && (
        <div style={styles.salaryRowSection}>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>Gross Augmentation Rate</p>
            <p style={styles.amount}>{displayAmount(apRate)}</p>
          </div>
          <br></br>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>Augmentation Pay Earned</p>
            <p style={styles.amount}>
              {displayAmount(computedValues.totalApEarned)}
            </p>
          </div>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>
              Pay Differential(INTERNATIONAL AIRPORTS)
            </p>
            <p style={styles.amount}>{displayAmount(0)}</p>
          </div>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}></p>
            <div style={styles.amtBoundary}>
              <p style={{ ...styles.amount }}>
                <b>{displayAmount(computedValues.totalEarned)}</b>
              </p>
            </div>
          </div>
        </div>
      )}
      {(checkCase("isBasicAddendum") || checkCase("isBasicBackpay")) && (
        <div style={styles.salaryRowSection}>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>Basic Salary Rate</p>
            <p style={styles.amount}>
              {displayAmount(displayValues.basicRate)}
            </p>
          </div>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>
              Less: Absences/Lates/Undertimes(Basic)
            </p>
            <p style={styles.amount}>
              {displayAmount(displayValues.deductionDueToLeavesTardy)}
            </p>
          </div>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>Overpayment(BASIC)</p>
            <p style={styles.amount}>
              {displayAmount(displayValues?.overpaymentBasic)}
            </p>
          </div>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>Total Basic</p>
            <div style={styles.amtBoundary}>
              <p style={{ ...styles.amount }}>
                <b>{displayAmount(computedValues.totalBasic)}</b>
              </p>
            </div>
          </div>
          <br></br>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>PERA/ADA</p>
            <p style={styles.amount}>{displayAmount(displayValues?.peraAda)}</p>
          </div>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>
              Less: Absences/Lates/Undertimes(PERA ADA)
            </p>
            <p style={styles.amount}>
              {displayAmount(displayValues?.deductionPeraAda)}
            </p>
          </div>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>Overpayment (PERA/ADA)</p>
            <p style={styles.amount}>
              {displayAmount(displayValues?.overpaymentPeraAda)}
            </p>
          </div>

          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>Total PERA/ADA</p>
            <div style={styles.amtBoundary}>
              <p style={{ ...styles.amount }}>
                <b>{displayAmount(computedValues.totalPeraAda)}</b>
              </p>
            </div>
          </div>
          <br></br>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>
              <b>TOTAL BASIC EARNED</b>
            </p>
            <div style={styles.amtBoundary}>
              <p style={{ ...styles.amount }}>
                <b>{displayAmount(computedValues.totalBasicEarned)}</b>
              </p>
            </div>
          </div>
        </div>
      )}
      {(checkCase("isBasicJoSalary") || checkCase("isBasicJoAddendum")) && (
        <div style={styles.salaryRowSection}>
          <div style={styles.salaryRow}>
            <p style={styles.salaryRowLbl}>Basic Salary Rate</p>
            <p style={styles.amount}>
              {displayAmount(displayValues.basicRate)}
            </p>
          </div>
        </div>
      )}
      <br></br>
      <div style={{ ...styles.salaryRowSection, ...styles.deductionLbl }}>
        DEDUCTIONS
      </div>
      {(checkCase("isApGeneralNewly") || checkCase("isApBackPay")) &&
        _renderDeductions(
          _getObjectsSection("ap", computedValues, displayValues),
          styles
        )}
      {checkCase("isBasicJoSalary") &&
        _renderDeductions(
          _getObjectsSection("jo", computedValues, displayValues),
          styles
        )}
      {checkCase("isBasicJoAddendum") &&
        _renderDeductions(
          _getObjectsSection("backpay", computedValues, displayValues),
          styles
        )}

      {_getContributions(params_1)}
      {_getDeductions(params_2)}

      {_getNetPay(styles, computedValues)}
    </>
  );
}

const _renderDeductions = (values = {}, styles) => {
  return Object.entries(values).map(([key, rawValue], index) => {
    const value = rawValue ?? 0;
    return (
      <div style={styles.salaryRowSection} key={index}>
        <div style={styles.salaryRow}>
          <p style={styles.salaryRowLbl}>{key}</p>
          <p style={styles.amount}>{displayAmount(value)}</p>
        </div>
      </div>
    );
  });
};

const _getNetPay = (styles, computedValues) => {
  return (
    <div style={styles.salaryRowSection}>
      <div style={styles.salaryRow}>
        <p style={styles.salaryRowLbl}>
          <b>NET PAY</b>
        </p>
        <div style={styles.amtBoundary}>
          <p style={{ ...styles.amount }}>
            <b>{displayAmount(computedValues.netPay)}</b>
          </p>
        </div>
      </div>
    </div>
  );
};
